import React from 'react';
import Content from '../../molecules/Content';
export interface OptinMailErrorContentProps {
  title: string;
  detail: string;
}

/**
 * メール受信の許諾エラー画面コンテンツ部
 */
const OptinMailErrorContent: React.FC<OptinMailErrorContentProps> = ({ title, detail }) => {
  return (
    <div className='mo-container'>
      <Content title={title} detail={detail} titleClassName='mo-title' detailClassName='mo-text' />
    </div>
  );
};
export default OptinMailErrorContent;
